/**
 * @module qbLinkage/detectChanges/detectUserFilterChanges
 * @description 仅 userFilter 类别
 */

import { isCompareUserGroupActive } from '../handlers/columnSort/untils/compareUserGroup';
import type { IQBSnapshot, TQBEvent } from '../types';
import type { IPartialQBChangeSet } from './partialChangeSet';

export function detectUserFilterChanges(
  _prev: IQBSnapshot,
  next: IQBSnapshot,
): IPartialQBChangeSet {
  const events: TQBEvent[] = ['userFilterGroupChanged'];

  return {
    events,
    userFilterGroup: { enabled: isCompareUserGroupActive(next) },
  };
}
